<template>
  <div class="picture">
    <input
      class="d-none"
      type="file"
      ref="file"
      accept=".jpg, .jpeg, .png"
      v-on:change="handleFileUpload"
    />
    <v-avatar class="picture__avatar" v-if="value" size="78">
      <v-img
        :src="
          !value.id
            ? $getFileUrl(value)
            : value.id
            ? chatApiDomain + '/static/' + value.name + value.extension
            : ''
        "
      />
    </v-avatar>
    <BaseTooltip
      :customClass="'tooltip ' + (value ? 'picture--ready' : '')"
      :tooltip="
        file || value
          ? localStorage.translations.pages.common.buttons['obnovit-fotografiyu']
          : localStorage.translations.pages.common.buttons['zagruzit-fotografiyu']
      "
    >
      <BaseButton
        round
        icon_only
        default_icon="button-upload"
        :size="!value ? 78 : 34"
        @click="onFileSelect"
        :customClass="{ 'px-2': value }"
      />
    </BaseTooltip>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'ChatModalGroupPicture',
  props: {
    value: [File, String, Object ],
  },
  data() {
    return {
      file: null,
    }
  },
  computed: {
    ...mapState(['chatApiDomain']),
  },
  methods: {
    handleFileUpload(e) {
      // console.log('handleFileUpload', e.target.files)
      this.$emit('input', e.target.files[0])
    },
    onFileSelect() {
      const input = this.$refs.file
      input.click()
    },
  },
}
</script>

<style lang="scss" scoped>
 .picture {
  position: relative;
  &__avatar {
    box-shadow: 0px 4px 4px rgba(133, 133, 133, 0.25);
  }
  :deep().tooltip {
    line-height: 1;
    &.picture--ready {
      position: absolute;
      right: -10px;
      bottom: -10px;
    }
  }
}
</style>
